module.exports = __webpack_public_path__ + "static/media/yves-saint-laurent-kouros-big.ef40caa9.png";